import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { TagProducaoStruct } from '../../../../../shared/services/structs/suprimentos/tag-producao.struct';

export interface AlterarTagsOrdemProducaoDialogData {
  listaTags: TagProducaoStruct[];
  quantidadeSelecionada: number;
}

/**
 * Alterar tags em lote (secao 3.7 da US#141200). O dialogo so devolve a escolha — quem chama a API
 * e a tela de lista, para o tratamento de erro e o refresh ficarem num lugar so.
 */
@Component({
  selector: 'app-alterar-tags-ordem-producao-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    MatCheckboxModule,
  ],
  templateUrl: './alterar-tags-ordem-producao-dialog.component.html',
  styleUrls: ['./alterar-tags-ordem-producao-dialog.component.css'],
})
export class AlterarTagsOrdemProducaoDialogComponent {
  /** 'incluir' mantem as existentes; 'excluir' remove as marcadas. */
  public modo: 'incluir' | 'excluir' = 'incluir';
  public textoBusca = '';
  public tagsSelecionadas = new Set<number>();

  constructor(
    public dialogRef: MatDialogRef<AlterarTagsOrdemProducaoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlterarTagsOrdemProducaoDialogData,
  ) {}

  public get tagsFiltradas(): TagProducaoStruct[] {
    const busca = this.textoBusca.trim().toLowerCase();
    if (!busca) return this.data.listaTags;
    return this.data.listaTags.filter((t) => t.descricao.toLowerCase().includes(busca));
  }

  public get contadorTexto(): string {
    const count = this.tagsSelecionadas.size;
    return count === 1 ? '1 tag selecionada' : `${count} tags selecionadas`;
  }

  public get textoAjuda(): string {
    return this.modo === 'incluir'
      ? 'As tags selecionadas serão adicionadas às ordens, mantendo as existentes.'
      : 'As tags selecionadas serão removidas das ordens selecionadas.';
  }

  /** Aplicar fica desabilitado até pelo menos uma tag ser marcada (seção 3.7). */
  public get podeAplicar(): boolean {
    return this.tagsSelecionadas.size > 0;
  }

  public alternarTag(idTagProducao: number): void {
    if (this.tagsSelecionadas.has(idTagProducao)) {
      this.tagsSelecionadas.delete(idTagProducao);
      return;
    }
    this.tagsSelecionadas.add(idTagProducao);
  }

  public aplicar(): void {
    if (!this.podeAplicar) return;

    this.dialogRef.close({
      listIdTagProducao: Array.from(this.tagsSelecionadas),
      isIncluir: this.modo === 'incluir',
    });
  }
}
